import { Help } from '@mui/icons-material';
import { Box, MenuItem } from '@mui/material';
import Typography from '@mui/material/Typography';
import _ from 'lodash';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { menuItemLayout } from '../../common/popover/userPopover/userPopoverStyles';
import { STATIC_ROUTES } from '../../../routes/Routes';

const HELP_MAPPING: { regex: RegExp; path: string }[] = [
  {
    regex: /-templates\//,
    path: '/automations-and-integrations/using-templates',
  },
  {
    regex: /^\/accounts/,
    path: '/using-schedulink/accounts-and-contacts',
  },
  {
    regex: /^\/contacts/,
    path: '/using-schedulink/accounts-and-contacts',
  },
  {
    regex: /^\/events/,
    path: '/using-schedulink/managing-events',
  },
  {
    regex: /^\/tasks/,
    path: '/using-schedulink/tasks-and-workflows',
  },
  {
    regex: /^\/preferences/,
    path: '/setup-and-configuration/preferences',
  },
  {
    regex: /^\/user-roles/,
    path: '/setup-and-configuration/user-permissions',
  },
];

export default function HelpLink() {
  const location = useLocation();
  const linkFromPath = () => {
    const urlMatch = _.find(HELP_MAPPING, (mappingObj) => !!location.pathname.match(mappingObj.regex));

    return `${STATIC_ROUTES.HELP_CENTER_URL}${urlMatch == null ? '' : urlMatch.path}`;
  };

  return (
    <Box sx={{ height: '100%' }}>
      <MenuItem component="a" href={linkFromPath()} target="_blank" rel="noopener noreferrer" sx={menuItemLayout}>
        <Help color="action" />
        <Typography>Help Center</Typography>
      </MenuItem>
    </Box>
  );
}
